<tt-page class="col-xs-12 col-md-6 sp-0" *ngIf="!!setting">
    <tt-card>
        <tt-tabs ttRememberId="w_stockcountdatas.gb_countstatus" [(ttSelectedId)]="setting.gb_countstatus" (ttSelectedIdChange)="onTabChange()">
            <tt-tab ttId="APPROVED" ttLabel="gb_countstatus_approved"></tt-tab>
            <tt-tab ttId="NOTAPPROVED" ttLabel="gb_countstatus_notapproved"></tt-tab>
        </tt-tabs>

        <form class="form-horizontal sp-0" name="formStockCountDatasSearch" novalidate (ngSubmit)="searchItems()" method="get" role="form">
            <tt-input ttRememberId="w_stockcountdatas.searchtext" ttLabel="searchtext" ttFocus="false" [(ttModel)]="setting.searchtext" (ttModelChange)="onChanged($event, 'searchtext')" [ttButtons]="searchTextButtons"></tt-input>
        </form>

        <form class="form-horizontal sp-0" name="formStockCountDatasPageNo" novalidate (ngSubmit)="searchItems()" method="get" role="form">
            <tt-input-number ttLabel="pageno" [(ttModel)]="setting.pageno" (ttModelChange)="onChanged($event, 'pageno')" ttTextAlign="right" ttFormatNumber ttDecimals ttUnaryButtons></tt-input-number>
        </form>
    </tt-card>

    <tt-list-legacy [listItems]="itemsListStockCountDatas" ltype="multi" [designVar]="'s12t0'" typevar="g"></tt-list-legacy>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-buttons-radio class="col-xs-12 sp-0" tt-buttons="vm.model.bgCountStatus.buttons" tt-model="vm.model.bgCountStatus.selected" tt-change="vm.selectBgCountStatus($value)"></tt-buttons-radio>

        <form class="form-horizontal im-no-pad" name="formStockCountDatasSearch" ng-submit="vm.searchStockCountDatasList()" novalidate method="get" role="form">
            <tt-input-buttons class="col-xs-12 sp-0" tt-label="searchtext" tt-model="vm.model.setting.searchtext" tt-on-blur="vm.onBlur('searchtext')" tt-change="vm.onChanged($value, 'searchtext')" tt-placeholder="" tt-buttons="vm.model.searchTextButtons" tt-readonly="false"></tt-input-buttons>
        </form>

        <form class="form-horizontal im-no-pad" name="formStockCountDatas2" ng-submit="vm.searchStockCountDatasList()" novalidate method="get" role="form">
            <tt-input-number tt-label="pageno" tt-model="vm.model.setting.pageno" tt-change="vm.onChanged($value, 'pageno')" tt-text-align="center" tt-unary-buttons="true"></tt-input-number>
        </form>
    </tt-card>

    <tt-list class="col-xs-12 col-md-6 sp-0" list-items="vm.model.itemsListStockCountDatas" badge="" ltype="multi" design-var="s12t0" typevar="g"></tt-list>
</tt-page>-->
